import { Button } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import SearchBar from '../../components/SearchBar';
import TableComponent from '../../components/TableComponent';
import { showError } from '../../constants/toasts';
import { successToast } from '../../helpers';
import MainContainer from '../../layout/MainContainer';
import AddNotification from '../../Modals/addNotification';
import {
  useAddNotificationMutation,
  useLazyGetNotificationQuery,
} from '../../service/notification';
import { CommonBody } from '../../types/General';
import { generateEncryptedKeyBody } from '../../utils/crypto';
import { Notifications_Type, USER_TYPE } from '../../utils/enums';
import { isValidInput } from '../../utils/validations';

const ManageNotifications = () => {
  const navigate = useNavigate();
  const [getNotification] = useLazyGetNotificationQuery();
  const [addNotification] = useAddNotificationMutation();
  const [openModal, setOpenModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState<boolean>(false);
  const [selectedId, setSelectedId] = useState<number>(-1);
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>('');
  const [totalCount, setTotalCount] = useState<number>(0);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [notification, setNotification] = useState<any>([]);

  const totalPages = Math.ceil(totalCount / 10);
  const onPageChange = (e: any, newPage: number) => {
    setPage(newPage + 1);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const columns: GridColDef<(typeof notification)[number]>[] = [
    {
      flex: 0.6,
      minWidth: 200,
      field: 'title',
      headerName: 'Title',
      editable: false,
      sortable: false,
    },
    {
      flex: 0.6,
      minWidth: 350,
      field: 'message',
      headerName: 'Message',
      editable: false,
      sortable: false,
    },
    {
      flex: 0.6,
      minWidth: 150,
      field: 'sendTo',
      headerName: 'Send To',
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return <div className="user_block">{USER_TYPE[row.role] || '-'}</div>;
      },
    },
    {
      flex: 0.6,
      minWidth: 200,
      field: 'notificationsType',
      headerName: 'Notifications Type',
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return <div className="user_block">{Notifications_Type[row.broadCastType] || '-'}</div>;
      },
    },
    {
      flex: 0.4,
      minWidth: 200,
      field: 'date',
      headerName: 'Date',
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return <div className="user_block">{moment(row?.createdAt).format('lll') || '-'}</div>;
      },
    },
    // {
    //   flex: 0.1,
    //   minWidth: 80,
    //   field: "action",
    //   headerName: "Action",
    //   editable: false,
    //   sortable: false,
    //   renderCell: ({ row }) => {
    //     return (
    //       <div className="table_actions">

    //       <Box className="table_actions">
    //                    <Tooltip title="Delete">
    //                        <IconButton
    //                        sx={{
    //                         color:"red",
    //                         ":hover":{
    //                           color:"white"
    //                         }
    //                        }}
    //                          onClick={() => {
    //                           setSelectedId(row?.id);
    //                           setOpen(true);
    //                         }}
    //                       >
    //                         <Delete />
    //                       </IconButton>
    //                     </Tooltip>
    //                   </Box>

    //       </div>
    //     );
    //   },
    // },
  ];

  const handleAddNotification = async (data: any) => {
    try {
      const body = {
        title: data.title,
        message: data.message,
        role: data.role,
        type: data.type,
      };

      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await addNotification(encryptedBody).unwrap();
      if (response.statusCode === 200) {
        getNotificationList();
        successToast('Notification added successfully');
      }
    } catch (error) {
      showError('Error adding notification:');
    } finally {
      setOpenModal(false);
    }
  };

  const getNotificationList = async () => {
    setIsLoading(true);

    try {
      const body = {
        start: page,
        length: 10,
        search: debouncedSearchTerm.trim(),
      };
      const res = await getNotification({
        page,
        limit: 10,
        search: debouncedSearchTerm,
      }).unwrap();
      if (res?.statusCode === 200) {
        setNotification(res?.data?.data || []);
        setCount(res?.data?.count);
      } else {
        setNotification([]);
      }
    } catch (error: any) {
      showError(error?.data?.message || '');
    }
    setIsLoading(false);
    // ref?.current?.complete();
  };
  useEffect(() => {
    getNotificationList();
  }, [page, debouncedSearchTerm]);

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Manage Notifications</h1>
        <p>
          <span onClick={() => navigate('/dashboard')}>Dashboard</span> - Manage Notifications
        </p>
      </div>

      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setDebouncedSearchTerm}
              value={searchTerm}
              onCross={() => setSearchTerm('')}
              onChange={(val: any) => {
                if (isValidInput(val.target.value)) {
                  setSearchTerm(val.target.value);
                }
              }}
              placeholder={''}
            />
          </div>
          <div className="right_s">
            <Button className="btn btn_secondary" onClick={() => setOpenModal(true)}>
              Add Notification
            </Button>
          </div>
        </div>
        <div className="sorting_table">
          <TableComponent
            columns={columns}
            rows={notification}
            count={count}
            page={page}
            onPageChange={onPageChange}
            loading={isLoading}
          />
        </div>
        {/* <TableContainer className="table_container">
          <Box className="heading"></Box>
          <Table
            sx={{ minWidth: 650 }}
            aria-label="simple table"
            className="v3"
          >
            <TableHead>
              <TableRow>
                <TableCell>Sr</TableCell>
                <TableCell>Title</TableCell>
                <TableCell>Message</TableCell>
                <TableCell>Send To</TableCell>
                <TableCell>Notifications Type</TableCell>
                <TableCell>Date</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {notification?.length ? (
                notification.map((row: any, i: string) => (
                  <TableRow>
                    <TableCell align="center">{i + 1}</TableCell>
                    <TableCell>{row.title}</TableCell>
                    <TableCell>{row.message}</TableCell>
                    <TableCell>
                      { USER_TYPE[row.role] || "-"}
                    </TableCell>
                    <TableCell>
                      { Notifications_Type[row.broadCastType] || "-"}
                    </TableCell>
                    <TableCell>
                      {" "}
                      {moment(row?.createdAt).format("YYYY-MM-DD") || "-"}
                    </TableCell>

                    {
                      // isDeleteAllowed(7) &&
                      // <TableCell align="center">
                      //   <Box className="table_actions">
                      //     <Tooltip title="Delete">
                      //       <IconButton
                      //         onClick={() => {
                      //           setSelectedId(row?.id);
                      //           setOpen(true);
                      //         }}
                      //       >
                      //         <DeleteIcon />
                      //       </IconButton>
                      //     </Tooltip>
                      //   </Box>
                      // </TableCell>
                    }
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell align="center" colSpan={6}>
                    No Notifications Found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer> */}
      </div>
      {/* <Pagination
        module={notification}
        page={page}
        onPageChange={onPageChange}
        totalPages={totalPages}
        totalCount={count}
        setPage={setPage}
      /> */}

      <AddNotification
        open={openModal}
        onClose={handleCloseModal}
        setOpen={setOpenModal}
        handleSubmit={handleAddNotification}
      />
    </MainContainer>
  );
};

export default ManageNotifications;
